import { render, staticRenderFns } from "./GlobalConfigUpdateDialogBulkOfferThreshold.vue?vue&type=template&id=5d732b97"
import script from "./GlobalConfigUpdateDialogBulkOfferThreshold.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigUpdateDialogBulkOfferThreshold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports